export default "__VITE_ASSET__VEhs1Y3u__"